import Composto from './Composto'

export default class CandidatoFormacao {

  constructor() {
    this.id = 0;
    this.candidato_id = new Composto();
    this.tp_formacao = new Composto();
    this.tp_concluso = new Composto();
    this.tp_turno = new Composto();
    this.nome = '';
    this.ano_conclusao = '';
    this.curso = '';
    this.detalhes = '';
  }

}
